import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import "./application.css";
import "@/styles/driver-custom.css";

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob("../pages/**/*.vue", { eager: true });
    return pages[`../pages/${name}.vue`];
  },
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mount(el);
  },
  progress: {
    color: "#0284c7",
  },
});
